export default "__VITE_ASSET__BG313T_I__"